// The length of grace period allows the scroll position to be readjusted due
// to loading content
export const ADJUST_SCROLL_TO_HASH_THRESHOLD = 5000;
